<div class="mc-master self-service-portal">
    <div class="mc-device-devices scroll-panel-devices">
        <div class="inner-scrollee">
            <div class="scroll-gap"></div>
            <ssp-devices-menu></ssp-devices-menu>
            <ssp-ticket-list></ssp-ticket-list>
        </div>
    </div>
    <div class="scroll-panel-details">
        <div class='inner-scrollee'>
            <div class='scroll-gap'></div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<ssp-snackbar></ssp-snackbar>

<div mc-status-notification-bar></div>